import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { LEFT, RIGHT, ENTER, EXIT, DOWN } from '../../util/remoteButtons';

import { Wrapper, PlaylistItem, PlaylistImage } from './styles';

const reorderPlaylists = (playlists, targetIndex, centerIndex) => {
  const items = playlists.slice(0);

  if (targetIndex > centerIndex) {
    const offset = targetIndex - centerIndex;
    const playlistsToAppend = items.splice(0, offset);
    items.push(...playlistsToAppend);
  } else if (targetIndex < centerIndex) {
    const offset = centerIndex - targetIndex;
    const playlistsToPrepend = items.splice(-1 + -offset, offset);
    items.unshift(...playlistsToPrepend);
  }

  return items;
};

const HomePlaylistCarousel = ({ playlists, startingPlaylist, hasFocus, onNavigateExit, onSelectPlaylist }) => {
  const [orderedPlaylists, setOrderedPlaylists] = useState(playlists);
  const [selectedPlaylist, setSelectedPlaylist] = useState(
    playlists.findIndex((pl) => pl.playlistId === startingPlaylist)
  );

  useEffect(() => {
    const targetIndex = orderedPlaylists.findIndex((pl) => pl.playlistId === startingPlaylist);
    const centerIndex = Math.floor(orderedPlaylists.length / 2);
    const items = reorderPlaylists(orderedPlaylists, targetIndex, centerIndex);

    setOrderedPlaylists(() => items);
    setSelectedPlaylist(() => centerIndex);
  }, []);

  // When playlists change, reset the playlist order
  useEffect(() => {
    const targetIndex = playlists.findIndex((pl) => pl.playlistId === startingPlaylist);
    const centerIndex = Math.floor(playlists.length / 2);
    const items = reorderPlaylists(playlists, targetIndex, centerIndex);

    setOrderedPlaylists(() => items);
    setSelectedPlaylist(() => centerIndex);
  }, [playlists]);

  useEffect(() => {
    if (hasFocus) {
      window.onkeydown = (e) => {
        switch (e.keyCode) {
          case LEFT: {
            const items = orderedPlaylists.slice(0);
            items.unshift(items.pop());
            setOrderedPlaylists(() => items);
            break;
          }
          case RIGHT: {
            const items = orderedPlaylists.slice(0);
            items.push(items.shift());
            setOrderedPlaylists(() => items);
            break;
          }
          case DOWN: {
            onNavigateExit();
            break;
          }
          case ENTER: {
            onSelectPlaylist(orderedPlaylists[selectedPlaylist].playlistId);
            break;
          }
          case EXIT: {
            onNavigateExit();
            break;
          }
          default:
            break;
        }
      };
    }
  });

  const itemWidth = 20;

  const baseOffset = selectedPlaylist * -itemWidth + (100 - itemWidth) / 2;

  const renderItem = (playlist, index) => {
    const current = orderedPlaylists[selectedPlaylist]?.playlistId === playlist?.playlistId;
    const offset = baseOffset + itemWidth * index;

    return (
      <PlaylistItem key={`playlist-carousel-item-${playlist.playlistId}`} offset={offset} itemWidth={itemWidth}>
        <PlaylistImage src={playlist.img?.image.high} current={current} hasFocus={hasFocus} />
      </PlaylistItem>
    );
  };

  return <Wrapper>{orderedPlaylists.map(renderItem)}</Wrapper>;
};

HomePlaylistCarousel.propTypes = {
  playlists: PropTypes.array,
  startingPlaylist: PropTypes.string,
  hasFocus: PropTypes.bool.isRequired,
  onSelectPlaylist: PropTypes.func,
  onNavigateExit: PropTypes.func,
};

HomePlaylistCarousel.defaultProps = {
  playlists: [],
  startingPlaylist: null,
  onSelectPlaylist: () => {},
  onNavigateExit: () => {},
};

export default HomePlaylistCarousel;
